import { render, staticRenderFns } from "./ResourceSchedule.vue?vue&type=template&id=05f2a834&scoped=true"
import script from "./ResourceSchedule.vue?vue&type=script&lang=js"
export * from "./ResourceSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f2a834",
  null
  
)

export default component.exports